import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters({
			CUSTOMER: 'customerId',
			CUSTOMER_NAME: 'customerName',
		}),
	},
	watch: {
		CUSTOMER: {
			handler() {
				this.query(null, true);
			},
		},
	},
};
